import Routes from "./Routes";
//import { useEffect, useState } from "react";

import {
  LoadedContractsDataProvider,
  WalletContentsDataProvider,
  NamesDataProvider,
  Web3ContextProvider,
} from "./contexts";
import WalletBalancesProvider from "./contexts/WalletBalancesContext";

const App = () => {
  // eslint-disable-next-line no-unused-vars
  // const [route, setRoute] = useState();

  // useEffect(() => {
  //   setRoute(window.location.pathname);
  // }, [setRoute]);

  return (
    <div className="App">
      <Web3ContextProvider>
        <NamesDataProvider>
          <LoadedContractsDataProvider>
            <WalletContentsDataProvider>
              <WalletBalancesProvider>
                <Routes />
              </WalletBalancesProvider>
            </WalletContentsDataProvider>
          </LoadedContractsDataProvider>
        </NamesDataProvider>
      </Web3ContextProvider>
    </div>
  );
};

export default App;
